import React, { useState } from 'react';

import MultiSelect, { Option } from 'components/elements/MultiSelect';

export interface CoffeeTypeOption extends Option {
  priceSystem: string;
}

interface CoffeeTypesSelectProps {
  name: string;
  options: CoffeeTypeOption[];
  defaultValue?: CoffeeTypeOption[];
  placeholder?: string;
  isDisabled?: boolean;
  required?: boolean;
}

// PLA-1099: un contrato a precio fijo aplica a varios tipos de café, pero todos del MISMO modo
// de liquidación: los escalares del contrato (fixed_price, base_factor, los factores de malla)
// están calibrados para una sola fórmula. Parchment paga por kg de pergamino comparando factores
// de malla; ExportableGreen paga por kg de excelso estimado.
//
// Esto es UX: la garantía real es FixedPriceContract#coffee_types_share_price_system.
const CoffeeTypesSelect: React.FC<CoffeeTypesSelectProps> = ({
  name,
  options,
  defaultValue = [],
  placeholder,
  isDisabled = false,
  required = false,
}) => {
  const [selected, setSelected] = useState<CoffeeTypeOption[]>(defaultValue);
  const lockedSystem = selected[0]?.priceSystem;

  return (
    <MultiSelect
      name={name}
      options={options}
      value={selected}
      onChange={(next) => setSelected(next as CoffeeTypeOption[])}
      placeholder={placeholder}
      isDisabled={isDisabled}
      required={required}
      isOptionDisabled={(option: Option) =>
        Boolean(lockedSystem) && (option as CoffeeTypeOption).priceSystem !== lockedSystem
      }
    />
  );
};

export default CoffeeTypesSelect;
